module.exports = __webpack_public_path__ + "static/media/productMasterActive.8507dea7.svg";